import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

import "../../styles/components/contactUs/contactUsPage.css";

export const ContactUsPageComponent = ({ companyReducer }) => {
  const [company, setCompany] = useState();

  useEffect(() => {
    if (companyReducer.company) setCompany(companyReducer.company);
  }, [companyReducer.company]);

  const sendToEmailClicked = () => {
    window.location.href = `mailto:${company?.contactEmail}`;
  };

  const makePhoneCallClicked = () => {
    window.location.href = `tel:${company?.contactPhone}`;
  };

  return (
    <div className="contactPageContainer">
      <header className="contactHero">
        <h1 className="contactTitle">נתקלתם בבעיה? יש לכם שאלה?</h1>
        <p className="contactSubtitle">תוכלו ליצור איתנו קשר באופן הבא</p>
      </header>

      <div className="contactCard">
        <button
          type="button"
          className="contactRow"
          onClick={sendToEmailClicked}
          aria-label={`דוא\"ל: ${company?.contactEmail ?? ""}`}
        >
          <span className="contactIconWrap" aria-hidden>
            <EmailIcon sx={{ fontSize: 22 }} />
          </span>
          <span className="contactTextBlock">
            <span className="contactLabel">דוא&quot;ל</span>
            <span className="contactValue">{company?.contactEmail ?? "—"}</span>
          </span>
        </button>
        <button
          type="button"
          className="contactRow"
          onClick={makePhoneCallClicked}
          aria-label={`טלפון: ${company?.contactPhone ?? ""}`}
        >
          <span className="contactIconWrap" aria-hidden>
            <PhoneIcon sx={{ fontSize: 22 }} />
          </span>
          <span className="contactTextBlock">
            <span className="contactLabel">טלפון</span>
            <span className="contactValue">{company?.contactPhone ?? "—"}</span>
          </span>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  companyReducer: state.companyReducer,
});

const mapDispatchToProps = (dispatch) => ({
  //
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsPageComponent);
